// ─── ACTION TYPES ─────────────────────────────────────────────────────────────

export const TEF_INTERNAL_ACTIONS = {
	// Import File
	TEF_IMPORT_REQUEST: 'TEF_IMPORT_REQUEST',
	TEF_IMPORT_SUCCESS: 'TEF_IMPORT_SUCCESS',
	TEF_IMPORT_FAILURE: 'TEF_IMPORT_FAILURE',

	// Get Last Update
	TEF_GET_LAST_UPDATE_REQUEST: 'TEF_GET_LAST_UPDATE_REQUEST',
	TEF_GET_LAST_UPDATE_SUCCESS: 'TEF_GET_LAST_UPDATE_SUCCESS',
	TEF_GET_LAST_UPDATE_FAILURE: 'TEF_GET_LAST_UPDATE_FAILURE',

	// Generate Result
	TEF_GENERATE_REQUEST: 'TEF_GENERATE_REQUEST',
	TEF_GENERATE_SUCCESS: 'TEF_GENERATE_SUCCESS',
	TEF_GENERATE_FAILURE: 'TEF_GENERATE_FAILURE',

	// Send Emails
	TEF_SEND_EMAILS_REQUEST: 'TEF_SEND_EMAILS_REQUEST',
	TEF_SEND_EMAILS_SUCCESS: 'TEF_SEND_EMAILS_SUCCESS',
	TEF_SEND_EMAILS_FAILURE: 'TEF_SEND_EMAILS_FAILURE',

	// Extensions History
	TEF_EXTENSIONS_HISTORY_REQUEST: 'TEF_EXTENSIONS_HISTORY_REQUEST',
	TEF_EXTENSIONS_HISTORY_SUCCESS: 'TEF_EXTENSIONS_HISTORY_SUCCESS',
	TEF_EXTENSIONS_HISTORY_FAILURE: 'TEF_EXTENSIONS_HISTORY_FAILURE',

	// Repository Import
	REPO_IMPORT_REQUEST: 'REPO_IMPORT_REQUEST',
	REPO_IMPORT_SUCCESS: 'REPO_IMPORT_SUCCESS',
	REPO_IMPORT_FAILURE: 'REPO_IMPORT_FAILURE',

	// Repository Get Last Update
	REPO_GET_LAST_UPDATE_REQUEST: 'REPO_GET_LAST_UPDATE_REQUEST',
	REPO_GET_LAST_UPDATE_SUCCESS: 'REPO_GET_LAST_UPDATE_SUCCESS',
	REPO_GET_LAST_UPDATE_FAILURE: 'REPO_GET_LAST_UPDATE_FAILURE',

	// Repository Export
	REPO_EXPORT_REQUEST: 'REPO_EXPORT_REQUEST',
	REPO_EXPORT_SUCCESS: 'REPO_EXPORT_SUCCESS',
	REPO_EXPORT_FAILURE: 'REPO_EXPORT_FAILURE',
};

// ─── ACTION CREATORS ──────────────────────────────────────────────────────────

// Import File
export const tefImportRequest  = ()        => ({ type: TEF_INTERNAL_ACTIONS.TEF_IMPORT_REQUEST });
export const tefImportSuccess  = (payload) => ({ type: TEF_INTERNAL_ACTIONS.TEF_IMPORT_SUCCESS, payload });
export const tefImportFailure  = (error)   => ({ type: TEF_INTERNAL_ACTIONS.TEF_IMPORT_FAILURE, error });

// Get Last Update
export const tefGetLastUpdateRequest = ()        => ({ type: TEF_INTERNAL_ACTIONS.TEF_GET_LAST_UPDATE_REQUEST });
export const tefGetLastUpdateSuccess = (payload) => ({ type: TEF_INTERNAL_ACTIONS.TEF_GET_LAST_UPDATE_SUCCESS, payload });
export const tefGetLastUpdateFailure = (error)   => ({ type: TEF_INTERNAL_ACTIONS.TEF_GET_LAST_UPDATE_FAILURE, error });

// Generate Result
export const tefGenerateRequest = ()        => ({ type: TEF_INTERNAL_ACTIONS.TEF_GENERATE_REQUEST });
export const tefGenerateSuccess = (payload) => ({ type: TEF_INTERNAL_ACTIONS.TEF_GENERATE_SUCCESS, payload });
export const tefGenerateFailure = (error)   => ({ type: TEF_INTERNAL_ACTIONS.TEF_GENERATE_FAILURE, error });

// Send Emails
export const tefSendEmailsRequest = ()        => ({ type: TEF_INTERNAL_ACTIONS.TEF_SEND_EMAILS_REQUEST });
export const tefSendEmailsSuccess = (payload) => ({ type: TEF_INTERNAL_ACTIONS.TEF_SEND_EMAILS_SUCCESS, payload });
export const tefSendEmailsFailure = (error)   => ({ type: TEF_INTERNAL_ACTIONS.TEF_SEND_EMAILS_FAILURE, error });

// Extensions History
export const tefExtensionsHistoryRequest = ()        => ({ type: TEF_INTERNAL_ACTIONS.TEF_EXTENSIONS_HISTORY_REQUEST });
export const tefExtensionsHistorySuccess = (payload) => ({ type: TEF_INTERNAL_ACTIONS.TEF_EXTENSIONS_HISTORY_SUCCESS, payload });
export const tefExtensionsHistoryFailure = (error)   => ({ type: TEF_INTERNAL_ACTIONS.TEF_EXTENSIONS_HISTORY_FAILURE, error });

// Repository Import
export const repoImportRequest = ()        => ({ type: TEF_INTERNAL_ACTIONS.REPO_IMPORT_REQUEST });
export const repoImportSuccess = (payload) => ({ type: TEF_INTERNAL_ACTIONS.REPO_IMPORT_SUCCESS, payload });
export const repoImportFailure = (error)   => ({ type: TEF_INTERNAL_ACTIONS.REPO_IMPORT_FAILURE, error });

// Repository Get Last Update
export const repoGetLastUpdateRequest = ()        => ({ type: TEF_INTERNAL_ACTIONS.REPO_GET_LAST_UPDATE_REQUEST });
export const repoGetLastUpdateSuccess = (payload) => ({ type: TEF_INTERNAL_ACTIONS.REPO_GET_LAST_UPDATE_SUCCESS, payload });
export const repoGetLastUpdateFailure = (error)   => ({ type: TEF_INTERNAL_ACTIONS.REPO_GET_LAST_UPDATE_FAILURE, error });

// Repository Export
export const repoExportRequest = ()        => ({ type: TEF_INTERNAL_ACTIONS.REPO_EXPORT_REQUEST });
export const repoExportSuccess = (payload) => ({ type: TEF_INTERNAL_ACTIONS.REPO_EXPORT_SUCCESS, payload });
export const repoExportFailure = (error)   => ({ type: TEF_INTERNAL_ACTIONS.REPO_EXPORT_FAILURE, error });